import FormSandboxUI from './FormSandboxUI';
import SandboxLoader from './SandboxLoader';

export default function formSandboxInit(e: Event, url: string) {
    const formSandboxUI = new FormSandboxUI();
    formSandboxUI.clickHandler();
    const lightboxEl = formSandboxUI.getLightboxEl;
    const sandboxLoader = new SandboxLoader(lightboxEl, url);
    sandboxLoader.load(e);
}
